var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-item",on:{"click":function($event){return _vm.onItemClick()}}},[_c('div',{staticClass:"menu-item__icon"}),_c('div',{staticClass:"menu-item__text"},[_vm._v(_vm._s(_vm.item.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }